module.exports = __webpack_public_path__ + "asset/image/logo-5754.svg";